import React from 'react';
import PropTypes from 'prop-types';
import {
  Layout,
  Row,
  Col,
  Menu,
} from 'antd';
import { Link } from 'react-router-dom';

import { UserBar } from '../../../containers/Page/';

import styles from './AppBar.module.css';

const { Header } = Layout;
const MenuItem = Menu.Item;

const AppBar = ({
  user,
  isAuthenticated,
  location,
  trigger,
}) => {
  const path = location.pathname.slice(1);

  const contentBar = isAuthenticated ? (
    <Row>
      <Col xs={12}>
        {trigger}
      </Col>
      <Col xs={12}>
        <UserBar user={user} />
      </Col>
    </Row>
  ) : (
    <Row>
      <Col
        xs={18}
        lg={23}
      >
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[path]}
          className={styles['top-menu']}
        >
          <MenuItem key="login">
            <Link to="/login">Log In</Link>
          </MenuItem>
          <MenuItem key="signup">
            <Link to="/signup">Sign Up</Link>
          </MenuItem>
          <MenuItem key="reset">
            <Link to="/reset">Reset Password</Link>
          </MenuItem>
        </Menu>
      </Col>
    </Row>
  );

  return (
    <Header className={styles['app-bar']}>
      {contentBar}
    </Header>
  );
};

AppBar.propTypes = {
  user: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
};

export default AppBar;
